import React, { useEffect, useMemo } from 'react';
import { Modal } from 'react-bootstrap';
import { usePeriodeKurbanUIContext } from '../PeriodeKurbanUIContext';
import { PeriodeKurbanEditDialogHeader } from './PeriodeKurbanEditDialogHeader';
import { PeriodeKurbanEditForm } from './PeriodeKurbanEditForm';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import * as actions from '../../../../_redux/periode-kurban/periodeKurbanAction';
import { toast } from 'react-toastify';
import { toastOption } from '../../../../../../../_metronic/_helpers';

export const PeriodeKurbanEditDialog = ({ id, show, onHide }) => {

    // PeriodeKurban UI Context
    const periodeKurbanUIContext = usePeriodeKurbanUIContext();
    const periodeKurbanUIProps = useMemo(() => {
        return {
            initPeriodeKurban: periodeKurbanUIContext.initPeriodeKurban,
            queryParams: periodeKurbanUIContext.queryParams,
            setQueryParams: periodeKurbanUIContext.setQueryParams,
        };
    }, [periodeKurbanUIContext]);

    // PeriodeKurban Redux state
    const dispatch = useDispatch();
    const { actionsLoading, periodeKurbanForEdit, error, roleMaster } = useSelector(
        (state) => ({
            actionsLoading: state.periodeKurbans.actionsLoading,
            periodeKurbanForEdit: state.periodeKurbans.periodeKurbanForEdit,
            roleMaster: state.periodeKurbans.roleMaster,
            error: state.periodeKurbans.error
        }),
        shallowEqual,
    );

    if (error) {
        toast.error(error, toastOption)
    }
    useEffect(() => {
        // server call for getting PeriodeKurban by id
        dispatch(actions.fetchPeriodeKurban(id));
    }, [id, dispatch]);

    const savePeriodeKurban = (periodeKurban) => {
        if (!id) {
            dispatch(actions.createPeriodeKurban(periodeKurban)).then((response) => {
                if (response)
                    toast.success(response.message, toastOption);
                dispatch(actions.fetchPeriodeKurbans(periodeKurbanUIProps.queryParams)).then(() => onHide());
            });

        } else {
            dispatch(actions.updatePeriodeKurban(periodeKurban)).then((response) => {
                if (response)

                    toast.success(response.message, toastOption);
                dispatch(actions.fetchPeriodeKurbans(periodeKurbanUIProps.queryParams)).then(() => onHide());
            });
        }
    };

    return (
        <Modal
            show={show}
            onHide={onHide}
            aria-labelledby="modal-sizes-title-lg"
            size="xl"
            backdrop="static"
            fullscreen={true}
            animation={true}
        >
            <PeriodeKurbanEditDialogHeader id={id} />
            <PeriodeKurbanEditForm
                savePeriodeKurban={savePeriodeKurban}
                actionsLoading={actionsLoading}
                periodeKurban={periodeKurbanForEdit || periodeKurbanUIProps.initPeriodeKurban}
                onHide={onHide}
                roleMaster={roleMaster}
                id={id}
            />
        </Modal>
    );
};
